import { map, switchMap, filter, withLatestFrom, catchError, debounceTime, pairwise, combineLatestWith, take } from 'rxjs/operators';
import { fromEventPattern, from, timeout, merge } from 'rxjs';
import lodashGet from 'lodash/get';
import { EventEmitter } from 'events';
import { api as masterApi } from '@/api/api';
import { apis } from '@/config';
export class IM_Later {
    constructor() {
        this.sdk = null;
        this.observable = null;
        this.myEvent = new EventEmitter();
        this.getRealIdList = async () => {
            var _a, _b;
            const laterRes = await this.imHttpApi.syncLater();
            const idList = Array.isArray((_a = laterRes === null || laterRes === void 0 ? void 0 : laterRes.data) === null || _a === void 0 ? void 0 : _a.sessions) ? (_b = laterRes === null || laterRes === void 0 ? void 0 : laterRes.data) === null || _b === void 0 ? void 0 : _b.sessions.map((item) => `${item.session_type}-${item.session_id}`) : [];
            return idList;
        };
        this.updateLater = (params) => {
            const { sessionId, sessionType, isLater } = params;
            const numSessionId = sessionId.split('-')[1];
            if (isLater) {
                this.imHttpApi.completeLater(numSessionId);
            }
            else {
                const addParams = {
                    session_id: numSessionId,
                    session_type: sessionType,
                };
                this.imHttpApi.addLater(addParams);
            }
        };
        this.imHttpApi = masterApi.requireLogicalApi(apis.imTeamApiImpl);
        this.nimApi = masterApi.requireLogicalApi('NIM');
    }
    getSubject() {
        return this.observable;
    }
    init(sdk) {
        this.sdk = sdk;
        const oncustomsysmsg = (handler) => {
            this.sdk.subscrible('oncustomsysmsg', handler);
        };
        const offcustomsysmsg = (handler) => {
            this.sdk.unSubcrible('oncustomsysmsg', handler);
        };
        const onconnect = (handler) => {
            this.sdk.subscrible('onconnect', handler);
        };
        const offconnect = (handler) => {
            this.sdk.unSubcrible('onconnect', handler);
        };
        const $sessionStream = this.sdk.sessionStream.getSubject();
        const $sessionReady = $sessionStream.pipe(map(list => list.length), filter(len => len > 0), take(1));
        const onsessionRenderComplete = (handler) => {
            this.myEvent.addListener(IM_Later.EventDeclare.sessionRenderComplete, handler);
        };
        const offsessionRenderComplete = (handler) => {
            this.myEvent.removeListener(IM_Later.EventDeclare.sessionRenderComplete, handler);
        };
        const $sessionRenderComplete = fromEventPattern(onsessionRenderComplete, offsessionRenderComplete);
        const $sessionConnect = fromEventPattern(onconnect, offconnect);
        const $request = merge($sessionRenderComplete, $sessionConnect).pipe(debounceTime(200), switchMap(() => {
            const _request = this.getRealIdList();
            return from(_request).pipe(timeout(15000));
        }), catchError(err => {
            console.warn('[im.later]interface error', err);
            return $sessionStream.pipe(map(sessionList => sessionList.filter(item => lodashGet(item, 'localCustom.later', false)).map(item => item.id)));
        }));
        const _notify = fromEventPattern(oncustomsysmsg, offcustomsysmsg).pipe(debounceTime(200), filter(data => {
            var _a, _b;
            const msgType = (_b = JSON.parse(((_a = data) === null || _a === void 0 ? void 0 : _a.content) || '{}')) === null || _b === void 0 ? void 0 : _b.subType;
            return msgType === 'session_later';
        }), map(data => {
            var _a, _b;
            const laterMsg = JSON.parse(((_b = JSON.parse(((_a = data) === null || _a === void 0 ? void 0 : _a.content) || '{}')) === null || _b === void 0 ? void 0 : _b.data) || '{}');
            const idList = Array.isArray(laterMsg === null || laterMsg === void 0 ? void 0 : laterMsg.sessions) ? laterMsg === null || laterMsg === void 0 ? void 0 : laterMsg.sessions.map((item) => `${item.session_type}-${item.session_id}`) : [];
            return idList;
        }));
        const $notify = $sessionReady.pipe(switchMap(() => _notify));
        const $observable = merge($request, $notify);
        $observable
            .pipe(withLatestFrom($sessionStream))
            .pipe(filter(([, sessionList]) => sessionList.length > 0), map(([laterIdList, sessionList]) => {
            const sessionIdList = sessionList.filter(item => !lodashGet(item, 'localCustom.later', false)).map(item => item.id);
            return laterIdList.filter((item) => sessionIdList.includes(item));
        }), filter(laterIdList => laterIdList.length > 0))
            .subscribe(laterIdList => {
            laterIdList.forEach((item) => this.nimApi.sessionStream.updateLocalCustom(item, { later: true }));
        });
        $observable
            .pipe(withLatestFrom($sessionStream))
            .pipe(filter(([, sessionList]) => sessionList.length > 0), map(([laterIdList, sessionList]) => {
            const sessionIdList = sessionList.filter(item => lodashGet(item, 'localCustom.later', false)).map(item => item.id);
            return sessionIdList.filter((item) => !laterIdList.includes(item));
        }), filter(sessionIdList => sessionIdList.length > 0))
            .subscribe(sessionIdList => {
            sessionIdList.forEach((item) => this.nimApi.sessionStream.updateLocalCustom(item, { later: false }));
        });
        $sessionStream
            .pipe(map(sessions => sessions.length), pairwise(), filter(([prevCount, nextCount]) => nextCount - prevCount >= 2), combineLatestWith($request), filter(([, idList]) => idList.length > 0), take(10))
            .subscribe(([, idList]) => {
            idList.forEach(id => {
                this.nimApi.sessionStream.updateLocalCustom(id, { later: true });
            });
        });
        this.observable = $observable;
    }
    getLaterList() {
        this.myEvent.emit(IM_Later.EventDeclare.sessionRenderComplete, '');
    }
}
IM_Later.EventDeclare = {
    sessionRenderComplete: 'sessionRenderComplete',
};
